var _TopTriangle, _TopTriangle2, _BottomTriangle, _BottomTriangle2, _BottomTriangle3, _BottomTriangle4, _BottomTriangle5, _TopTriangle3, _TopTriangle4, _LeftTriangle, _LeftTriangle2, _RightTriangle, _RightTriangle2, _LeftTriangle3;
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This is the little triangle that the small tooltip uses.
 * We need some extra logic to render the correct triangle based on the position prop and the collisions.
 */

var commonTriangleClasses = 'tw-absolute tw-border-solid';
export var TopTriangle = function TopTriangle(_ref) {
  var left = _ref.left;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(commonTriangleClasses, " tw--top-0.4 tw-border-b-neutral-dark-700 dark:tw-border-b-neutral-light-200 tw-border-b-0.4 tw-border-x-transparent tw-border-x-0.4 tw-border-t-0"),
    style: {
      left: left || 8
    }
  });
};
export var BottomTriangle = function BottomTriangle(_ref2) {
  var left = _ref2.left;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(commonTriangleClasses, " tw--bottom-0.4 tw-border-t-neutral-dark-700 dark:tw-border-t-neutral-light-200 tw-border-t-0.4 tw-border-x-transparent tw-border-x-0.4 tw-border-b-0"),
    style: {
      left: left || 8
    }
  });
};
export var LeftTriangle = function LeftTriangle() {
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(commonTriangleClasses, " tw--left-0.4 tw-border-solid tw-border-r-neutral-dark-700 dark:tw-border-r-neutral-light-200 tw-border-r-0.4 tw-border-y-transparent tw-border-y-0.4 tw-border-l-0"),
    style: {
      top: 'calc(100% / 2 - 4px)'
    }
  });
};
export var RightTriangle = function RightTriangle() {
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(commonTriangleClasses, " tw--right-0.4 tw-border-solid tw-border-l-neutral-dark-700 dark:tw-border-l-neutral-light-200 tw-border-l-0.4 tw-border-y-transparent tw-border-y-0.4 tw-border-r-0"),
    style: {
      top: 'calc(100% / 2 - 4px)'
    }
  });
};
export var renderTriangleBasedOnCollisionsAndPosition = function renderTriangleBasedOnCollisionsAndPosition(collisions, position) {
  if (position === 'top') {
    if (collisions.top) {
      /** Adjust the X axis position based on the left and right collisions */
      if (collisions.right) return _TopTriangle || (_TopTriangle = /*#__PURE__*/_jsx(TopTriangle, {
        left: "calc(100% - 16px)"
      }));
      return _TopTriangle2 || (_TopTriangle2 = /*#__PURE__*/_jsx(TopTriangle, {}));
    }
    if (collisions.bottom) {
      if (collisions.right) return _BottomTriangle || (_BottomTriangle = /*#__PURE__*/_jsx(BottomTriangle, {
        left: "calc(100% - 16px)"
      }));
    }
    if (collisions.right) return _BottomTriangle2 || (_BottomTriangle2 = /*#__PURE__*/_jsx(BottomTriangle, {
      left: "calc(100% - 16px)"
    }));
    return _BottomTriangle3 || (_BottomTriangle3 = /*#__PURE__*/_jsx(BottomTriangle, {}));
  }
  if (position === 'bottom') {
    if (collisions.bottom) {
      if (collisions.right) return _BottomTriangle4 || (_BottomTriangle4 = /*#__PURE__*/_jsx(BottomTriangle, {
        left: "calc(100% - 16px)"
      }));
      return _BottomTriangle5 || (_BottomTriangle5 = /*#__PURE__*/_jsx(BottomTriangle, {
        left: 8
      }));
    }
    if (collisions.right) {
      return _TopTriangle3 || (_TopTriangle3 = /*#__PURE__*/_jsx(TopTriangle, {
        left: "calc(100% - 16px)"
      }));
    }
    return _TopTriangle4 || (_TopTriangle4 = /*#__PURE__*/_jsx(TopTriangle, {}));
  }
  if (position === 'left') {
    if (collisions.left) {
      if (collisions.bottom) return _LeftTriangle || (_LeftTriangle = /*#__PURE__*/_jsx(LeftTriangle, {}));
      return _LeftTriangle2 || (_LeftTriangle2 = /*#__PURE__*/_jsx(LeftTriangle, {}));
    }
    return _RightTriangle || (_RightTriangle = /*#__PURE__*/_jsx(RightTriangle, {}));
  }
  if (position === 'right') {
    if (collisions.right) {
      return _RightTriangle2 || (_RightTriangle2 = /*#__PURE__*/_jsx(RightTriangle, {}));
    }
    return _LeftTriangle3 || (_LeftTriangle3 = /*#__PURE__*/_jsx(LeftTriangle, {}));
  }
  return null;
};